import * as React from 'react';

import {
  sections,
  // utils
} from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { SectionContentLinkListIdFour } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdFour) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdFour]: {
      id: SectionContentLinkListIdFour;
      title: string;
    };
  } = {
    [SectionContentLinkListIdFour.OurCommitmentsToYou]: {
      id: SectionContentLinkListIdFour.OurCommitmentsToYou,
      title: sections.tabFourSection.subsection1.title(),
    },
  };

  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionFourContainer = () => {
  /**
   * @todo: add real text
   */
  return {
    sections: {
      one: {
        titleElement: setTitleElement(SectionContentLinkListIdFour.OurCommitmentsToYou),
        text: (
          <FormattedText>
            <P1 as="p" html={sections.tabFourSection.subsection1.column1()} />
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/landing/assets/photos/landing-section-1-Good-to-know.png`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        whatIsAggregating: {
          title: sections.tabFourSection.subsection1.whatIsAggregating.title(),
          content: sections.tabFourSection.subsection1.whatIsAggregating.content(),
        },
        goodToKnow: {
          title: sections.tabFourSection.subsection1.goodToKnow.title(),
          content: sections.tabFourSection.subsection1.goodToKnow.content(),
        },
      },
      two: {
        table: sections.tabFourSection.subsection2.table,
      },
    },
  };
};
